<template>
  <div class="tab-slice-placeholder">
    <div class="row" style="margin: 0 3%">
      <div class="tab-grid">
        <div class="row">
          <div class="col-md-4 col-lg-3 col-xlg-3 col-sm-6 col-xs-6">
            <div class="tbc-plch-card">
              <div class="trapezoid-placeholder"></div>
              <div class="triangle-bottom-placeholder"></div>
              <div class="triangle-top-placeholder"></div>
              <div class="tbc-plch-card-top"></div>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-xlg-3 col-sm-6 col-xs-6">
            <div class="tbc-plch-card">
              <div class="trapezoid-placeholder"></div>
              <div class="triangle-bottom-placeholder"></div>
              <div class="triangle-top-placeholder"></div>
              <div class="tbc-plch-card-top"></div>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-xlg-3 col-sm-6 col-xs-6">
            <div class="tbc-plch-card">
              <div class="trapezoid-placeholder"></div>
              <div class="triangle-bottom-placeholder"></div>
              <div class="triangle-top-placeholder"></div>
              <div class="tbc-plch-card-top"></div>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-xlg-3 col-sm-6 col-xs-6">
            <div class="tbc-plch-card">
              <div class="trapezoid-placeholder"></div>
              <div class="triangle-bottom-placeholder"></div>
              <div class="triangle-top-placeholder"></div>
              <div class="tbc-plch-card-top"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabSlidesPlaceholder",
  data() {
    return {
      poster: require("@/assets/icons/Plchdr.png")
    };
  }
};
</script>

<style lang="scss">
.tab-slice-placeholder {
  .tabs {
    // border-bottom: 3px solid #e4e4e4;
    padding: 6px 0;
    ul {
      li {
        display: inline-block;
        width: 20%;
        height: 28px;
        // background: linear-gradient(to right, #e4e4e4, #c4c4c4);
        background: linear-gradient(to right, #b9b7b7, #9c9797);
        margin-right: 20px;
        border-radius: 4px;
      }
    }
  }
  .tbc-plch-card {
    position: relative;
    // min-width: 270px;
    height: 400px;
    background: linear-gradient(to right, #e4e4e4, #c4c4c4);
    border-radius: 4px;
    margin: 20px 0;
  }
}
.trapezoid-placeholder {
  border-bottom: 40px solid #b5b5b5;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  height: 0;
  width: 170px;
  position: absolute;
  z-index: 10;
  transform: rotate(-45deg);
  top: 5%;
  left: -16%;
}
.triangle-bottom-placeholder {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-right: 7px solid #b5b5b5;
  border-bottom: 4px solid transparent;
  top: 27.2%;
  position: absolute;
  z-index: 10;
  left: -5px;
}
.triangle-top-placeholder {
  height: 0;
  width: 0;
  border-top: 5px solid transparent;
  border-right: 5px solid #b5b5b5;
  border-bottom: 4px solid transparent;
  position: absolute;
  z-index: 10;
  left: 40.5%;
  top: -7px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .tab-slice-placeholder {
    .tbc-plch-card {
      height: 210px;
    }
  }
  .trapezoid-placeholder {
    border-bottom: 25px solid #b5b5b5;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    height: 0;
    width: 90px;
    position: absolute;
    z-index: 10;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 3%;
    left: -20%;
  }
  .triangle-top-placeholder {
    left: 27.5%;
  }
  .triangle-bottom-placeholder {
    border-top: 9px solid transparent;
    border-right: 8px solid #b5b5b5;
    border-bottom: 3px solid transparent;
    top: 24%;
    position: absolute;
    z-index: 10;
    left: -8px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .tab-slice-placeholder {
    .tbc-plch-card {
      min-width: 230px;
      height: 350px;
    }
  }
  .trapezoid-placeholder {
    left: -20%;
  }
  .triangle-bottom-placeholder {
    top: 30%;
    position: absolute;
    z-index: 10;
    left: -7px;
  }
  .triangle-top-placeholder {
    border-top: 5px solid transparent;
    border-right: 8px solid #b5b5b5;
    border-bottom: 7px solid transparent;
    position: absolute;
    z-index: 10;
    left: 45%;
    top: -9px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .tab-slice-placeholder {
    .tbc-plch-card {
      min-width: 230px;
      height: 350px;
    }
  }
  .trapezoid-placeholder {
    left: -20%;
  }
  .triangle-bottom-placeholder {
    top: 30%;
    position: absolute;
    z-index: 10;
    left: -7px;
  }
  .triangle-top-placeholder {
    border-top: 5px solid transparent;
    border-right: 8px solid #b5b5b5;
    border-bottom: 7px solid transparent;
    position: absolute;
    z-index: 10;
    left: 45%;
    top: -9px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .tab-slice-placeholder {
    .tbc-plch-card {
      position: relative;
      // min-width: 270px;
      height: 400px;
    }
  }
  .trapezoid-placeholder {
    left: -18%;
  }
  .triangle-top-placeholder {
    left: 46.5%;
  }
}
// 4k
@media screen and (min-width: 1900px) {
  .tab-slice-placeholder {
    .tbc-plch-card {
      height: 600px;
    }
  }
  .trapezoid-placeholder {
    width: 190px;
    position: absolute;
    z-index: 10;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 4%;
    left: -13%;
  }
  .triangle-bottom-placeholder {
    border-top: 8px solid transparent;
    border-right: 8px solid #b5b5b5;
    border-bottom: 4px solid transparent;
    top: 19.2%;
    position: absolute;
    z-index: 10;
    left: -7px;
  }
  .triangle-top-placeholder {
    border-top: 5px solid transparent;
    border-right: 8px solid #b5b5b5;
    border-bottom: 11px solid transparent;
    position: absolute;
    z-index: 10;
    left: 30.5%;
    top: -12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/SliderCarouselPlaceholder.vue